import type { Point2D } from '@shared/models/geometry.model';
import { getDistance } from '@shared/helpers/geometry/coordinates.helpers';

/**
 * Soft-snap {@link tip} onto the horizontal or vertical axis through {@link origin}
 * when within {@link maxDistanceMeters}. Prefer the closer axis.
 */
export const softSnapToAxisAligned = (
  origin: Point2D,
  tip: Point2D,
  maxDistanceMeters: number,
): Point2D | undefined => {
  if (!(maxDistanceMeters > 0) || !Number.isFinite(maxDistanceMeters)) {
    return undefined;
  }

  const horizontal: Point2D = [tip[0], origin[1]];
  const vertical: Point2D = [origin[0], tip[1]];
  const distanceHorizontal = getDistance(tip, horizontal);
  const distanceVertical = getDistance(tip, vertical);

  if (
    distanceHorizontal <= maxDistanceMeters &&
    distanceHorizontal <= distanceVertical
  ) {
    return horizontal;
  }
  if (distanceVertical <= maxDistanceMeters) {
    return vertical;
  }
  return undefined;
};
